import _styled from "styled-components";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Skeleton } from "@crehana/ui";
import cn from "classnames";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from "styled-components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LearnMentorCardSkeleton = function LearnMentorCardSkeleton(_ref) {
  var isDark = _ref.isDark;
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    className: cn('rounded-10 flex flex-col overflow-hidden p-12', isDark ? 'bg-base-light-dark-mode' : 'bg-white shadow-1-dp'),
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center mb-12 flex-col",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "w-full h-144 rounded-10",
        isDark: isDark
      }), /*#__PURE__*/_jsx("div", {
        className: "flex items-center pt-12 justify-between w-full",
        children: /*#__PURE__*/_jsx(Skeleton, {
          className: "h-16 w-2/3",
          isDark: isDark
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mb-24",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex flex-wrap",
        children: Array.from({
          length: 4
        }).map(function (_, index) {
          return /*#__PURE__*/_jsx(Skeleton
          // biome-ignore lint/suspicious/noArrayIndexKey: index as key is acceptable here
          , {
            className: "h-24 w-1/4 rounded-5 mb-8 mr-8",
            isDark: isDark
          }, "mentor-card-skeleton-tags-".concat(index * 1));
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-auto justify-self-end",
      children: /*#__PURE__*/_jsx(Skeleton, {
        className: "h-40 w-full rounded-5",
        isDark: isDark
      })
    })]
  });
};
export default LearnMentorCardSkeleton;
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-1u8cfam-0"
})(["\n        min-height: 348px;\n      "]);